module.exports = __webpack_public_path__ + "img/chanp.54c9df1c.png";